var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDateTimeCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7C8.29333 7 6.5 8.79333 6.5 11C6.5 13.2067 8.29333 15 10.5 15C12.7067 15 14.5 13.2067 14.5 11C14.5 8.79333 12.7067 7 10.5 7ZM10.5 14C8.84 14 7.5 12.66 7.5 11C7.5 9.34 8.84 8 10.5 8C12.16 8 13.5 9.34 13.5 11C13.5 12.66 12.16 14 10.5 14Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H10V11.2067L11.2933 12.5L12 11.7933L11 10.7933V9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4H11V3H13V6H14V3C14 2.44667 13.5533 2 13 2H11V1H10V2H6V1H5V2H3C2.44667 2 2 2.44667 2 3V13C2 13.5533 2.44667 14 3 14H5V13H3V3H5V4H6V3H10V4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDateTimeCalendar);
export default __webpack_public_path__ + "static/media/ic-date-time-calendar.1e86d06715f96006d409b86fc5281182.svg";
export { ForwardRef as ReactComponent };